import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import moment from "moment";

import { useTableStyles as useStyles } from "./styles";
import { noselect } from "../../styles/common.css";
import { Link } from "react-router";

import Card from "@material-ui/core/Card";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "../Button"
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

const PendingConsolidation = (props) => {
  const classes = useStyles();
  const { pendingConsolidation, doFetchPendingConsolidation, doFetchGenerateConsolidatedPayment } = props;
  const [selectAll, setSelectAll] = useState(false);
  const [penConsolidation, setPenConsolidation] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);

  const handleCheckedBox = (memberID, value) => {
    let newArr = penConsolidation.map((item) =>
      item.member_id === memberID
        ? { ...item, checked: value ? value : !item.checked }
        : item
    );
    setPenConsolidation(newArr);
  };

  const handleCreate = () => {
    const consolidated = penConsolidation.filter((s) => s.checked)
    if (consolidated.length > 0) {
      handleClose()
      doFetchGenerateConsolidatedPayment(consolidated.map(x => x.account_id))
    }
  }

  const handleClose = () => {
    setOpenPopup(false);
  };

  useEffect(() => {
    doFetchPendingConsolidation()
  }, []);

  useEffect(() => {
    setPenConsolidation(pendingConsolidation?.accounts)
  }, [pendingConsolidation?.accounts]);

  useEffect(() => {
    let newArr = penConsolidation.map((item) => {
      return { ...item, checked: selectAll }
    });
    setPenConsolidation(newArr);
  }, [selectAll]);

  return (
    <Card className={classes.transactionPanel}>
      <h1 id="panel-title">
        Pending Consolidation Statements
        <div>
          <Button
            className={classes.sentButton}
            variant="raised"
            onClick={() => setOpenPopup(true)}
          >
            Consolidate Statements
          </Button>
        </div>
      </h1>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ height: "600px", overflow: "auto" }}>
          <Table stickyHeader>
            <TableHead className={`${classes.tableHeaderRow} ${noselect}`}>
              <TableRow>
                <TableCell align="left">
                  <Tooltip placement="bottom" title="Select All Approved">
                    <Checkbox
                      style={{ color: "white" }}
                      checked={selectAll}
                      onChange={() => setSelectAll(!selectAll)}
                    />
                  </Tooltip>
                </TableCell>
                <TableCell align="left">Bill to Name</TableCell>
                <TableCell align="left">Account Number</TableCell>
                <TableCell align="left">Member ID</TableCell>
                <TableCell align="left">Statements Generated</TableCell>
                <TableCell align="left">Statements Pending</TableCell>
                <TableCell align="left">Last Sent Statement Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {penConsolidation?.length > 0 ? (
                penConsolidation.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <Checkbox
                          onClick={(e) => e.stopPropagation()}
                          checked={item.checked ? item.checked : false}
                          onChange={() => handleCheckedBox(item.member_id)}
                        />
                      </TableCell>
                      <TableCell>{item.bill_to_name}</TableCell>
                      <TableCell>{item.account_number}</TableCell>
                      <TableCell>
                        <Link
                          style={{ color: "#3f51b5" }}
                          to={`/members/${item.member_id}/details`}
                        >
                          {item.member_id}
                        </Link>
                      </TableCell>
                      <TableCell>{item.statements_generated}</TableCell>
                      <TableCell>{item.statements_pending}</TableCell>
                      <TableCell>
                        {item.last_sent_statement_date
                          ? moment.utc(item.last_sent_statement_date).format("YYYY-MM-DD")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={10}>No Records Found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
      <Dialog
        className={classes.dialog}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openPopup}
      >
        {penConsolidation.filter((s) => s.checked).length > 0 ? (
          <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={openPopup}
          >
            <DialogContent dividers>
              Please confirm to generate consolidation statement for selected accounts.
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handleCreate()}>
                Accept
              </Button>
              <Button autoFocus onClick={() => handleClose()} color="secondary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        ) : (
          <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={openPopup}
          >
            <DialogContent dividers>
              Please select accounts to generate statements
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={() => handleClose()} color="secondary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Dialog>
    </Card>
  );
};

PendingConsolidation.propTypes = {
  doFetchPendingConsolidation: PropTypes.func.isRequired,
  doFetchGenerateConsolidatedPayment: PropTypes.func.isRequired,
  pendingConsolidation: PropTypes.array.isRequired,
};

export default PendingConsolidation;
